import ChannelsView from '../ChannelsView.vue'
import ChannelList from '../Pages/ChannelList.vue'
import ChannelEditor from '../Pages/ChannelEditor.vue'

const routes = [
  {
    path: '/mantenimiento/canales',
    component: ChannelsView,
    children: [
      { path: '', name: 'channel-list', component: ChannelList },
      { path: 'crear', name: 'channel-create', component: ChannelEditor },
      { path: ':id', name: 'channel-edit', component: ChannelEditor },
    ],
  },
]

export default routes
